<template>
  <div data-v-d871d47a="" data-v-4f04d936="" class="Findings">
    <div data-v-d871d47a="" class="head_area">
      <div data-v-d871d47a="" class="leftImg">
        <!--          <img data-v-d871d47a="" src="https://ws1003quans3.wjbsails.com/ng/h5_static/img/logo_icon.8abe279d.png" class="top_logo" />-->
      </div>
      <span data-v-d871d47a="" class="head_text">{{ $t('动态') }}</span><span data-v-d871d47a="" class="right_menu"></span>
    </div>
    <div data-v-d871d47a="" class="FindingsContent">


      <div data-v-d871d47a="" class="mentItem"  @click="$parent.goNav('/message')">
        <div data-v-d871d47a="" class="leftArea">
          <img
            data-v-d871d47a=""
            src="/static/image/new/dynamic-logo.png"
            alt=""
            class="menuIcon"
          /><span data-v-d871d47a="" class="mentText">{{ $t('官方动态') }}</span
        ><!---->

        </div>
        <div data-v-d871d47a="" class="rightArea">
          <img
            data-v-d871d47a=""
            src="/static/image/new/arrow-white.png"
            alt=""
            class="info_icon"
          />
        </div>
      </div>
      <div data-v-d871d47a="" class="mentItem">
        <div data-v-d871d47a="" class="leftArea">
          <img
            data-v-d871d47a=""
            src="/static/image/new/stage-logo.png"
            alt=""
            class="menuIcon"
          /><span data-v-d871d47a="" class="mentText">{{ $t('大舞台') }}</span
        ><!---->
        </div>
        <div data-v-d871d47a="" class="rightArea">
          <div data-v-d871d47a="" class="img-right-warp">
            <img data-v-d871d47a="" src="/static/image/new/stage-more-img.png" class="headImg" />
            <div class="text">{{ $t('精彩活动') }}</div>
          </div>
          <img
            data-v-d871d47a=""
            src="/static/image/new/arrow-white.png"
            alt=""
            class="info_icon"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.Findings[data-v-d871d47a] {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background-color: #000;

    color: #fff;
    background-image: url("/static/image/new/page-bg-img.png");
    background-size: cover;
    font-family: PingFang SC;
    padding-bottom: 1.79rem;  // 底部导航栏高度

}

.Findings .head_area[data-v-d871d47a] {
    height: 1.17rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    z-index: 999;
}

.Findings .head_area .leftImg[data-v-d871d47a] {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    width: 2.45333rem;
    height: .88rem;
    text-align: left;
    z-index: 999
}

.Findings .head_area .leftImg .top_logo[data-v-d871d47a] {
    margin-left: .26667rem;
    height: .88rem
}

.Findings .head_area .head_text[data-v-d871d47a] {
    font-size: .48rem;
    font-family: PingFang SC;
    font-weight: 500;
    width: 30%;
    color: #fff;
    text-align: center;
}

.Findings .head_area .right_menu[data-v-d871d47a] {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: right;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.Findings .head_area .right_menu .right_menu_down[data-v-d871d47a] {
    width: .53333rem;
    height: .53333rem
}

.Findings .head_area .right_menu .right_menu_notice[data-v-d871d47a] {
    width: auto;
    height: .53333rem;
    position: relative;
    margin-right: .8rem;
    margin-left: .4rem
}

.Findings .head_area .right_menu .right_menu_notice .right_menu_setting[data-v-d871d47a] {
    position: absolute;
    width: .64rem;
    height: .64rem;
    left: 0
}

.Findings .FindingsContent[data-v-d871d47a] {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column
}

.Findings .FindingsContent .mentItem,
.Findings .FindingsContent {
    display: flex;
    align-items: center
}

.Findings .FindingsContent .mentItem {

    justify-content: space-between;
    width: 9.2rem;
    height: 1.49rem;
    background: #fff;
    border-radius: .19rem;
    margin-bottom: .27rem;
    background: rgba(255, 255, 255, 0.10);
    border: 0.03rem solid rgba(255, 255, 255, 0.10);
}

.Findings .FindingsContent .mentItem .leftArea[data-v-d871d47a] {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.Findings .FindingsContent .mentItem .leftArea .menuIcon {
    width: 0.85rem;
    height: 0.85rem;
    margin-left: .27rem;
}

.Findings .FindingsContent .mentItem .leftArea .mentText {
    font-size: .37rem;
    font-weight: 500;
    color: #fff;
    margin-left: .24rem;
}

.Findings .FindingsContent .mentItem .leftArea .total[data-v-d871d47a] {
    min-width: .48rem;
    min-height: .48rem;
    background: #ff3170;
    border: .02667rem solid #fff;
    border-radius: 50%;
    padding-left: .10667rem;
    padding-right: .10667rem;
    padding-top: .02667rem;
    padding-bottom: .02667rem;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: .26667rem;
    font-family: PingFang SC;
    font-weight: 500;
    color: #fff;
    margin-left: .10667rem
}

.Findings .FindingsContent .mentItem .leftArea .total[data-v-d871d47a],.Findings .FindingsContent .mentItem .rightArea[data-v-d871d47a] {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center
}

.Findings .FindingsContent .mentItem .rightArea .img-right-warp {
  position: relative;
  .meanuImg {
    width: .72rem;
    height: .72rem
  }
  .text {
    position: absolute;
    bottom: 0.12rem;
    left: 0.08rem;
    right: 0.08rem;
    font-weight: 600;
    font-size: 0.18rem;
    color: #FFFFFF;
    text-align: center;
  }
}

.Findings .FindingsContent .mentItem .rightArea .headImg {
    width: 1.01rem;
    height: 1.01rem;
    border-radius: .08rem
}

.Findings .FindingsContent .mentItem .rightArea .info_icon[data-v-d871d47a] {
    width: 0.43rem;
    margin-left: .2rem;
    margin-right: .27rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/discover.vue